<template>
  <div id="page-entity-toba-details">
    <company-toba-form
        v-if="model"
        ref="form"
        v-model="model"
        :loading="loading"
        card-title="Edit"
    />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              class="my-4"
              @click="$router.push({ name: 'company.tobas.list'})"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              class="my-4"
              color="light"
              @click="save"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ViewModelMixin from '@/components/mixins/ViewModelMixin';
import SaveModelMixin from '@/components/mixins/SaveModelMixin';
import NotificationMixin from '@/components/mixins/NotificationMixin';
import CompanyTobaForm from './CompanyTobaForm';
import PageTitle from "@/views/components/extra-components/layout/PageTitle";
import CardPage from '@/views/components/Views/CardPage';

export default {
  name: 'FacilityEdit',
  components: {
    CompanyTobaForm,
    PageTitle,
    CardPage,
  },
  mixins: [ViewModelMixin, SaveModelMixin, NotificationMixin],
  data() {
    return {
      loading: false,
      modelEntity: this.$api.companyToba,
    };
  },
  computed: {
    id() {
      return this.$route.params.tobaId
    },
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    async fetch() {
      try {
        this.loading = true;
        const { data } = await this.$api.companyToba.get(this.id);
        this.model = data.data;

      } catch (e) {
        this.$vs.notify({
          title: 'Error occurred',
          text: 'Not able to retrieve TOBA details. Please try again.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      } finally {
        this.loading = false;
      }
    },
    getParams() {
      const data = this.getModelCopy(true);

      const references = [
        'TOBAType_FK',
      ];

      const dates = [
        'StartDate',
        'ExpiryDate',
      ];

      this.setDates(dates, data);
      this.setReferences(references, data);

      return data;
    },
    async save() {
      if (!this.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();

      try {
        const {data} = await this.$api.companyToba.update(this.id, params);
        this.notifySuccess('Facility updated');
        this.$router.back();
      } catch (e) {
        this.notifyError('Facility failed to be updated');
        console.error(e);
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>

</style>
